import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import ReactIcon from './IconBase';
import { normalizeTwoToneColors } from '../utils';
export function setTwoToneColor(twoToneColor) {
  var _normalizeTwoToneColo = normalizeTwoToneColors(twoToneColor),
      _normalizeTwoToneColo2 = _slicedToArray(_normalizeTwoToneColo, 2),
      primaryColor = _normalizeTwoToneColo2[0],
      secondaryColor = _normalizeTwoToneColo2[1];

  return ReactIcon.setTwoToneColors({
    primaryColor: primaryColor,
    secondaryColor: secondaryColor
  });
}
export function getTwoToneColor() {
  var colors = ReactIcon.getTwoToneColors();

  if (!colors.calculated) {
    return colors.primaryColor;
  }

  return [colors.primaryColor, colors.secondaryColor];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/es/components/twoTonePrimaryColor.js
// module id = 562
// module chunks = 0